/*
 * @Author: zd
 * @Date: 2022-11-23 08:22:04
 * @LastEditors: zd
 * @LastEditTime: 2023-02-09 13:19:46
 * @Description: 页面权限列表
 */
const state = {
  ruleList: [
    'CustHome' //首页
  ],
  istradeCustLogin: false
}

const mutations = {
  SET_RULE_LIST: (state, ruleList) => {
    state.ruleList = ruleList
  },
  SET_TRADE_CUST_LOGIN: (state, istradeCustLogin) => {
    state.istradeCustLogin = istradeCustLogin
  }
}
const actions = {}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
